import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["events", "fandoms", "topContents"]
  static values = {
    eventsUrl: String,
    fandomsUrl: String,
    topContentsUrl: String
  }

  connect() {
    this.loadSection(this.eventsUrlValue, this.eventsTarget)
    this.loadSection(this.fandomsUrlValue, this.fandomsTarget)
    this.loadSection(this.topContentsUrlValue, this.topContentsTarget)
  }

  loadSection(url, target) {
    fetch(url, { headers: { "Accept": "text/html" } })
      .then(response => response.text())
      .then(html => { target.innerHTML = html })
      .catch(() => { target.innerHTML = '<p class="text-muted small">Failed to load.</p>' })
  }
}
